import { Flex, LocalVideo, RemoteVideo } from '.';
import { useMediaQuery } from '../../../../helpers/useMediaQuery';
import { theme } from '../../design-system';

const TabletVideoChatSidebar = () => {
  const smallerTablets = useMediaQuery('(max-width: 1130px)');

  return (
    <Flex column justifyContent='flex-start' height='744px' alignItems='center' marginRight='0.25rem' width='calc(100vw - 744px - 2.75rem)'>
      <Flex width={smallerTablets ? '20vw' : '30vw'} minHeight='175px' marginBottom='1rem' borderRadius='4px' boxShadow={theme.elevations.elevation4}>
        <LocalVideo />
      </Flex>
      <Flex width={smallerTablets ? '20vw' : '30vw'} minHeight='175px' borderRadius='4px' boxShadow={theme.elevations.elevation4}>
        <RemoteVideo />
      </Flex>
    </Flex>
  );
};

export default TabletVideoChatSidebar;
